import { __rest, __assign } from './../../../external_lib/tslib/tslib.es6.js';
import React__default from 'react';
var LocationsFilled = function (_a) {
  var _b = _a.fill,
    fill = _b === void 0 ? 'currentColor' : _b,
    props = __rest(_a, ["fill"]);
  return React__default.createElement("svg", __assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("path", {
    d: "M10.0001 1.66663C6.77841 1.66663 4.16675 4.27829 4.16675 7.49996C4.16675 11.6666 10.0001 18.3333 10.0001 18.3333C10.0001 18.3333 15.8334 11.6666 15.8334 7.49996C15.8334 4.27829 13.2217 1.66663 10.0001 1.66663ZM10.0001 9.58329C8.84925 9.58329 7.91675 8.65079 7.91675 7.49996C7.91675 6.34913 8.84925 5.41663 10.0001 5.41663C11.1509 5.41663 12.0834 6.34913 12.0834 7.49996C12.0834 8.65079 11.1509 9.58329 10.0001 9.58329Z",
    fill: fill
  }));
};
export { LocationsFilled as default };
//# sourceMappingURL=LocationsFilled.js.map
